window['ThemeSection_ProductQuickBuy_Radio'] = ({
  product,
  variant,
  featuredMediaID,
  outOfStockText
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    addedToCart: false,
    addToCartText: "Add to Cart",
    outOfStockText: outOfStockText,
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get current_price() {
      return this.current_variant.price;
    },
    formatMoney(price) {
      if (!price) return '';
      let formatted = formatMoney(price, theme.moneyFormat);
      return formatted ? formatted.replace(/\.00(?=\s|$)/g, '').replace(/\.00$/, '') : '';
    },
    getVariantSubTitle(variantId) {
      const v = this.current_variant;
      if (!v || !v.title) return '';
      const titleLower = (this.product.title || '').toLowerCase();
      const isGum = titleLower.includes('gum');
      const unitWord = isGum ? 'gums' : 'mints';

      if (v.title.includes('(') && v.title.includes(')')) {
        const parts = v.title.split('(')[1].split(')')[0].trim();
        if (parts) return parts.toLowerCase();
      }

      const vTitleLower = v.title.toLowerCase();
      let packNum = 0;
      if (vTitleLower.includes('10')) packNum = 10;
      else if (vTitleLower.includes('6')) packNum = 6;
      else if (vTitleLower.includes('5')) packNum = 5;
      else if (vTitleLower.includes('4')) packNum = 4;
      else if (vTitleLower.includes('3')) packNum = 3;
      else if (vTitleLower.includes('2')) packNum = 2;
      else if (vTitleLower.includes('1')) packNum = 1;

      if (packNum > 0) {
        const perPackCount = isGum ? 9 : 12;
        return (packNum * perPackCount) + ' ' + unitWord;
      }
      return '';
    },
    getVariantUnitPriceText(variantId) {
      const v = this.current_variant;
      if (!v || !v.price) return '';
      const titleLower = (this.product.title || '').toLowerCase();
      const isGum = titleLower.includes('gum');
      const unitWord = isGum ? 'gum' : 'mint';
      const subTitle = this.getVariantSubTitle(variantId);
      
      if (!subTitle) return '';
      const match = subTitle.match(/(\d+)/);
      if (!match) return '';
      const totalCount = parseInt(match[1]);
      if (!totalCount || totalCount <= 0) return '';

      const priceInRupees = v.price / 100;
      const perUnitPrice = (priceInRupees / totalCount).toFixed(2);
      return '₹' + perUnitPrice + ' per ' + unitWord;
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;
      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }
      this.getOptions();
    },
    mainSelectorChange(evt) {
      const variantId = this.getSelectedVariant(evt);
      if (variantId) {
        const matchedVariant = ShopifyProduct.getVariantFromId(
          this.product,
          parseInt(variantId)
        );
        this.updateVariant(matchedVariant);
      }
    },

    getSelectedVariant(evt) {
      if (evt && evt.target && evt.target.value) {
        return evt.target.value;
      }
      const selectedRadio = this.$root.querySelector(`input[name="variant_id_choice"]:checked, input[name="id"]:checked, .variant-radio-pill:checked, .variant-radio:checked`);
      if (selectedRadio) {
        return selectedRadio.value;
      } else {
        return null;
      }
    },
    optionChange() {
      this.getOptions();
      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );
      this.updateVariant(matchedVariant);
    },
    updateVariant(variant) {
      this.current_variant = variant;
      if (this.current_variant) {
        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    submitForm(evt) {

      let button = evt.target.querySelector('.theme-button.card-atc-surface')
      this.addToCartText = "Loading"   
      evt?.preventDefault();
      this.loading = true;

      liveRegion(window.theme.strings.loading);
      const formData = new FormData(
        this.$root.querySelector('.quick-buy-product-form')
      );
      if (this.current_variant && this.current_variant.id) {
        formData.set('id', this.current_variant.id);
      }
      let modalCart = theme.settings.cart_type === 'modal';
      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count,cart-upsell-dynamic');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.status){
            alert(data.description)
            this.addToCartText = "Add to Cart"   
            return
          }
          this.loading = false;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
          }

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
          this.addToCartText = "Add to Cart"   
        })
        .catch((error) => {
          error.json().then((a) => {
            this.loading = false;
            alert(a.description);
          });
        });
    },
  };
};

window['ThemeSection_ProductQuickBuy'] = ({
  product,
  variant,
  featuredMediaID,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    addedToCart: false,
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get current_price() {
      return this.current_variant.price;
    },
    formatMoney(price) {
      return formatMoney(price, theme.moneyFormat);
    },
    getVariantSubTitle(variantId) {
      const v = this.current_variant;
      if (!v || !v.title) return '';
      const titleLower = (this.product.title || '').toLowerCase();
      const isGum = titleLower.includes('gum');
      const unitWord = isGum ? 'gums' : 'mints';

      if (v.title.includes('(') && v.title.includes(')')) {
        const parts = v.title.split('(')[1].split(')')[0].trim();
        if (parts) return parts.toLowerCase();
      }

      const vTitleLower = v.title.toLowerCase();
      let packNum = 0;
      if (vTitleLower.includes('10')) packNum = 10;
      else if (vTitleLower.includes('6')) packNum = 6;
      else if (vTitleLower.includes('5')) packNum = 5;
      else if (vTitleLower.includes('4')) packNum = 4;
      else if (vTitleLower.includes('3')) packNum = 3;
      else if (vTitleLower.includes('2')) packNum = 2;
      else if (vTitleLower.includes('1')) packNum = 1;

      if (packNum > 0) {
        const perPackCount = isGum ? 9 : 12;
        return (packNum * perPackCount) + ' ' + unitWord;
      }
      return '';
    },
    getVariantUnitPriceText(variantId) {
      const v = this.current_variant;
      if (!v || !v.price) return '';
      const titleLower = (this.product.title || '').toLowerCase();
      const isGum = titleLower.includes('gum');
      const unitWord = isGum ? 'gum' : 'mint';
      const subTitle = this.getVariantSubTitle(variantId);
      
      if (!subTitle) return '';
      const match = subTitle.match(/(\d+)/);
      if (!match) return '';
      const totalCount = parseInt(match[1]);
      if (!totalCount || totalCount <= 0) return '';

      const priceInRupees = v.price / 100;
      const perUnitPrice = (priceInRupees / totalCount).toFixed(2);
      return '₹' + perUnitPrice + ' per ' + unitWord;
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;
      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }
      this.getOptions();
    },
    mainSelectorChange(evt) {
      let variantId = null;
      if (evt && evt.target && evt.target.value) {
        variantId = evt.target.value;
      } else if (this.$refs.singleVariantSelector) {
        variantId = this.$refs.singleVariantSelector.value;
      } else {
        const checkedInput = this.$root.querySelector('input[name="variant_id_choice"]:checked, input[name="id"]:checked, .variant-radio-pill:checked');
        if (checkedInput) {
          variantId = checkedInput.value;
        }
      }
      if (variantId) {
        const matchedVariant = ShopifyProduct.getVariantFromId(
          this.product,
          parseInt(variantId)
        );
        this.updateVariant(matchedVariant);
      }
    },
    optionChange() {
      this.getOptions();
      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );
      this.updateVariant(matchedVariant);
    },
    updateVariant(variant) {
      this.current_variant = variant;
      if (this.current_variant) {
        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    submitForm(evt) {

      let button = this.productRoot.querySelector('.theme-button.card-atc-surface')
      button.innerHTML = "Loading"
      evt.preventDefault();
      this.loading = true;

      liveRegion(window.theme.strings.loading);
      const formData = new FormData(
        this.$root.querySelector('.quick-buy-product-form')
      );
      if (this.current_variant && this.current_variant.id) {
        formData.set('id', this.current_variant.id);
      }
      let modalCart = theme.settings.cart_type === 'modal';
      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count,cart-upsell-dynamic');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          this.loading = false;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
            document.body.classList.add('cart_open')
          }

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
          button.innerHTML = "Add to Cart"
        })
        .catch((error) => {
          error.json().then((a) => {
            this.loading = false;
            alert(a.description);
          });
        });
    },
  };
};
